import { makeMed3, makeMed4, makeReg3 } from './textStyles';
const tabsStyles = (tokens) => {
    const tabButtonShadow = `outset 0px 0px ${tokens.BorderWidth02} ${tokens.BorderWidth02} ${tokens.BorderFocus}`;
    return {
        baseStyle: {
            tablist: {
                borderBottom: 'none',
                marginTop: '24px',
                button: {
                    _focus: {
                        shadow: 'none',
                        outline: 'none',
                    },
                    _focusVisible: {
                        outlineColor: tokens.BorderFocus,
                        outlineWidth: tokens.BorderWidth02,
                        outline: tabButtonShadow,
                    },
                },
            },
            tabpanel: {
                padding: 0,
            },
        },
        variants: {
            sidebar: {
                tab: {
                    ...makeMed3(tokens),
                    bgColor: tokens.Layer01,
                    color: tokens.TextDark800,
                    _selected: {
                        bgColor: tokens.CanvasPrimary200,
                    },
                    h: '48px',
                    textAlign: 'left',
                    justifyContent: 'flex-start',
                },
                tablist: {
                    button: {
                        _focus: {
                            bgColor: tokens.CanvasPrimary200,
                        },
                        _focusVisible: {
                            bgColor: tokens.CanvasPrimary200,
                        },
                    },
                    mt: 0,
                },
                tabpanel: {
                    w: '540px',
                    maxW: '540px',
                },
            },
            button: {
                tab: {
                    ...makeMed4(tokens),
                    bgColor: tokens.CanvasTableHeader,
                    color: tokens.TextMedium600,
                    borderWidth: tokens.BorderWidth01,
                    borderColor: tokens.BorderPrimary,
                    _last: {
                        borderBottomRightRadius: tokens.BorderRadius02,
                        borderTopRightRadius: tokens.BorderRadius02,
                    },
                    _first: {
                        borderBottomLeftRadius: tokens.BorderRadius02,
                        borderTopLeftRadius: tokens.BorderRadius02,
                    },
                    _selected: {
                        bgColor: tokens.CanvasPrimary200,
                    },
                },
            },
            line: {
                tab: {
                    color: tokens.TextBlack800,
                    _selected: {
                        fontWeight: 500,
                        color: tokens.TextBlack800,
                        borderColor: tokens.BorderPrimary,
                    },
                },
            },
            'above-card': {
                tab: {
                    ...makeReg3(tokens),
                    h: '45px',
                    w: '146px',
                    bgColor: tokens.Layer04,
                    color: tokens.TextMedium600,
                    borderBottom: `1px solid ${tokens.BorderLight200}`,
                    borderRight: `1px solid ${tokens.BorderLight200}`,
                    _last: {
                        borderTopRightRadius: tokens.BorderRadius02,
                    },
                    _first: {
                        borderTopLeftRadius: tokens.BorderRadius02,
                    },
                    _selected: {
                        bgColor: tokens.Layer01,
                        borderBottom: 'none',
                        borderRight: 'none',
                        borderTop: `2px solid ${tokens.BorderPrimary}`,
                    },
                },
                tablist: {
                    marginTop: '0px',
                },
            },
            accordion: {
                tablist: {
                    mt: 0,
                },
                tab: {
                    color: tokens.TextDark800,
                    fontSize: tokens.TextHeadingLight6FontSize,
                    fontWeight: tokens.TextHeadingLight6FontWeight,
                    _selected: {
                        color: tokens.TextBlack800,
                        fontWeight: tokens.TextHeadingMedium6FontWeight,
                        borderBottomColor: tokens.BorderPrimary,
                        borderBottomWidth: tokens.BorderWidth02,
                    },
                },
            },
        },
    };
};
export default tabsStyles;
